/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/identityTheftMonitoringSubscriptionAuthenticationMappers";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a IdentityTheftMonitoringSubscriptionAuthentication. */
export class IdentityTheftMonitoringSubscriptionAuthentication {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a IdentityTheftMonitoringSubscriptionAuthentication.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls the EnrollmentAndAuthenticationAPIs to request ID verification questions to verify user's
   * identity.
   * @summary Gets the ID verification questions for user authentication.
   * @param [options] The optional parameters
   * @returns
   * Promise<Models.IdentityTheftMonitoringSubscriptionAuthenticationGetIDVerificationResponse>
   */
  getIDVerification(options?: Models.IdentityTheftMonitoringSubscriptionAuthenticationGetIDVerificationOptionalParams): Promise<Models.IdentityTheftMonitoringSubscriptionAuthenticationGetIDVerificationResponse>;
  /**
   * @param callback The callback
   */
  getIDVerification(callback: coreHttp.ServiceCallback<Models.GetIdVerificationApiResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getIDVerification(options: Models.IdentityTheftMonitoringSubscriptionAuthenticationGetIDVerificationOptionalParams, callback: coreHttp.ServiceCallback<Models.GetIdVerificationApiResponse>): void;
  getIDVerification(options?: Models.IdentityTheftMonitoringSubscriptionAuthenticationGetIDVerificationOptionalParams | coreHttp.ServiceCallback<Models.GetIdVerificationApiResponse>, callback?: coreHttp.ServiceCallback<Models.GetIdVerificationApiResponse>): Promise<Models.IdentityTheftMonitoringSubscriptionAuthenticationGetIDVerificationResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getIDVerificationOperationSpec,
      callback) as Promise<Models.IdentityTheftMonitoringSubscriptionAuthenticationGetIDVerificationResponse>;
  }

  /**
   * Calls the EnrollmentAndAuthenticationAPIs to submit ID verification answers to verify user's
   * identity.
   * @summary Submits the ID verification answers for user authentication.
   * @param [options] The optional parameters
   * @returns
   * Promise<Models.IdentityTheftMonitoringSubscriptionAuthenticationSubmitIDVerificationResponse>
   */
  submitIDVerification(options?: Models.IdentityTheftMonitoringSubscriptionAuthenticationSubmitIDVerificationOptionalParams): Promise<Models.IdentityTheftMonitoringSubscriptionAuthenticationSubmitIDVerificationResponse>;
  /**
   * @param callback The callback
   */
  submitIDVerification(callback: coreHttp.ServiceCallback<Models.SubmitIdVerificationDataApiResponse>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  submitIDVerification(options: Models.IdentityTheftMonitoringSubscriptionAuthenticationSubmitIDVerificationOptionalParams, callback: coreHttp.ServiceCallback<Models.SubmitIdVerificationDataApiResponse>): void;
  submitIDVerification(options?: Models.IdentityTheftMonitoringSubscriptionAuthenticationSubmitIDVerificationOptionalParams | coreHttp.ServiceCallback<Models.SubmitIdVerificationDataApiResponse>, callback?: coreHttp.ServiceCallback<Models.SubmitIdVerificationDataApiResponse>): Promise<Models.IdentityTheftMonitoringSubscriptionAuthenticationSubmitIDVerificationResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      submitIDVerificationOperationSpec,
      callback) as Promise<Models.IdentityTheftMonitoringSubscriptionAuthenticationSubmitIDVerificationResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getIDVerificationOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/SubscriptionAuthentication/id/verification/get",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.GetIdVerificationApiRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.GetIdVerificationApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const submitIDVerificationOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/SubscriptionAuthentication/id/verification/submit",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.SubmitIdVerificationDataApiRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.SubmitIdVerificationDataApiResponse
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
